(function() {
  'use strict';

  // Função para buscar e renderizar o botão "Próximo Volume" para cada item do carrinho
  function initCartNextVolumeButtons() {
    const buttons = document.querySelectorAll('.m-cart-next-volume-button');
    
    buttons.forEach((container) => {
      const productId = container.dataset.productId;
      if (!productId) return;

      // Limpa o conteúdo anterior para evitar duplicatas
      container.innerHTML = '';
      container.style.display = 'none';

      // Busca o produto complementar
      fetch(`/recommendations/products.json?product_id=${productId}&limit=1&intent=complementary`)
        .then(response => response.json())
        .then(data => {
          if (!data.products || data.products.length === 0) {
            return; // Não mostra nada se não houver produto complementar
          }

          const product = data.products[0];
          const variant = product.variants[0];
          const isAvailable = variant.available;

          if (!isAvailable) {
            return; // Não mostra se não estiver disponível
          }

          // Cria o botão
          const button = document.createElement('button');
          button.type = 'button';
          button.setAttribute('data-add-next-volume', '');
          button.setAttribute('data-variant-id', variant.id);
          button.setAttribute('data-product-handle', product.handle);
          
          // Imagem do produto
          const image = document.createElement('img');
          image.src = product.featured_image || '';
          image.alt = product.title;
          image.className = 'product-image';
          
          // Texto do botão
          const text = document.createTextNode('+ Levar também o próximo volume');
          
          button.appendChild(image);
          button.appendChild(text);
          
          container.appendChild(button);
          container.style.display = 'block';

          // Event listener para adicionar ao carrinho
          button.addEventListener('click', async function(e) {
            e.preventDefault();
            const variantId = this.getAttribute('data-variant-id');
            
            // Estado de loading
            button.disabled = true;
            const originalText = button.textContent;
            button.textContent = 'Adicionando...';
            
            try {
              const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  items: [{
                    id: variantId,
                    quantity: 1
                  }]
                })
              });
              
              if (response.ok) {
                // Atualiza o carrinho usando o método do tema primeiro
                const cartDrawer = document.querySelector('m-cart-drawer');
                if (cartDrawer && cartDrawer.onCartDrawerUpdate) {
                  cartDrawer.onCartDrawerUpdate();
                  // Abre o drawer se não estiver aberto
                  if (cartDrawer.open && typeof cartDrawer.open === 'function') {
                    cartDrawer.open();
                  } else if (cartDrawer.classList && !cartDrawer.classList.contains('m-cart-drawer--active')) {
                    window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.openCartDrawer);
                  }
                }
                
                // Aguarda um pouco para o carrinho atualizar e então dispara o evento
                setTimeout(() => {
                  document.dispatchEvent(new CustomEvent('cart:updated'));
                }, 100);
              } else {
                throw new Error('Erro ao adicionar ao carrinho');
              }
            } catch (error) {
              console.error('Erro ao adicionar produto ao carrinho:', error);
              button.textContent = originalText;
              button.disabled = false;
            }
          });
        })
        .catch(error => {
          console.error('Erro ao buscar produto complementar:', error);
        });
    });
  }

  // Inicializa quando o DOM estiver pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartNextVolumeButtons);
  } else {
    initCartNextVolumeButtons();
  }

  // Debounce para evitar múltiplas chamadas
  let reinitTimeout = null;
  function debouncedInit() {
    if (reinitTimeout) {
      clearTimeout(reinitTimeout);
    }
    reinitTimeout = setTimeout(() => {
      initCartNextVolumeButtons();
    }, 300);
  }

  // Re-inicializa quando o carrinho for atualizado
  if (window.MinimogEvents) {
    window.MinimogEvents.subscribe(window.MinimogTheme?.pubSubEvents?.cartUpdate || 'cart:update', () => {
      debouncedInit();
    });
  }

  // Observa mudanças no cart-drawer para re-inicializar
  function setupObserver() {
    const cartDrawer = document.querySelector('m-cart-drawer');
    if (!cartDrawer) {
      setTimeout(setupObserver, 500);
      return;
    }

    const observer = new MutationObserver((mutations) => {
      let shouldReinit = false;
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
              // Verifica se é um cart-item ou contém cart-items
              if (node.classList?.contains('m-cart-item') || 
                  node.classList?.contains('m-cart-drawer__items') ||
                  node.querySelector?.('.m-cart-item') ||
                  node.querySelector?.('.m-cart-next-volume-button')) {
                shouldReinit = true;
              }
            }
          });
        }
      });
      
      if (shouldReinit) {
        debouncedInit();
      }
    });

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true
    });

    // Observa quando o drawer abre
    const drawerObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (cartDrawer.classList.contains('m-cart-drawer--active')) {
            debouncedInit();
          }
        }
      });
    });

    drawerObserver.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  setupObserver();
})();

